import { createContext } from 'react';

import { getEmptyStatementSelectionProviderValue } from '@trqk/utils';

export const StatementSelectionContext =
    createContext<StatementSelectionProviderValue>(
        getEmptyStatementSelectionProviderValue(),
    );
